// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1VG1z","errorLogs":"styles_errorLogs__LP7oE"};